/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum VerhaeltnisZumVersicherungsnehmer {

    Ehepartner = 'Ehepartner',

    LebenspartnerInHaeuslicherGemeinschaft = 'LebenspartnerInHaeuslicherGemeinschaft',

    Kind = 'Kind',

    Elternteil = 'Elternteil',

    BruderSchwester = 'BruderSchwester',

    Groeltern = 'Großeltern',

    Sonstige = 'Sonstige'
}

